import React, { useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { StatusLayout } from '../Layout';


function StatusTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});

    const handleStatusFormLoad = useCallback(() => {
        props.statusFormLookupsLoad(formRefs);

    }, []);

    useEffect(() => {
        
    }, [props.formFields]);

    const handleSelectionChange = useCallback((name, value,e) => {
        props.handleStatusFieldChange(name, value?.selectedItem?.id,formRefs);
    }, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='E552B414-9347-4277-9574-48081F619053'
                layoutName='WMLotataEntryStatusForm'
                defaultFormSchema={StatusLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleSelectionChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleStatusFormLoad}
                handleSelectedItemChange={handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(StatusTab);
